export default __webpack_public_path__ + "static/media/SingleDegreeImg.3812f941.jpg";